var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(this.showMenu())?_c('SideMenu',{attrs:{"rotas":this.getRoutes(),"txtcolor":"#fff","bgcolor":"#2f96f3"}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"container-fluid"},[_c('transition',{attrs:{"name":"fade"}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e98cf4ce","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 20
// module chunks = 22